import { mergeClassnames } from '@heathmont/moon-core-tw';

const Container: FC = ({ children }) => (
  <div
    style={{ gridTemplateAreas: 'position user points' }}
    className={mergeClassnames(
      'grid h-[1.625rem] w-full grid-cols-[auto_repeat(2,1fr)] gap-4 gap-x-2 border-b border-dashed border-hit px-2 py-0 text-moon-12 last:border-none',
    )}
  >
    {children}
  </div>
);

export default Container;
